import { LetterSort } from "@app_schema";

// Shared by the page and by the route loader that warms its queries. The
// loader's variables have to match the page's first render exactly or Apollo
// misses the cache and both queries run twice, so neither value may be
// restated at either call site.
export const LETTER_WINDOW_SIZE = 20;

export const DEFAULT_LETTER_SORT = LetterSort.DateOldest;
